import { Component, computed, input } from '@angular/core';
import { NotificationLayoutComponent } from '../../notification-detail-layout/notification-detail-layout.component';
import { NotificationStep, TeacherNotification } from '../../../core/models/notification.model';

@Component({
  selector: 'wf-delinquent-login-notification',
  imports: [
    NotificationLayoutComponent
  ],
  template: `
    <wf-notification-layout
      headerTitle="💬 Time to check in — The following Student(s) hasn’t logged in for 3 weeks"
      [preambles]="[{
        text: 'The student(s) below haven’t logged in to WordFlight in over three weeks. '
          + 'Students see the best results with 60–80 minutes of practice each week, so this is worth a quick follow-up.'
        }]"
      [steps]="steps"
      [ids]="ids()"
      ctaLabel="Open Group Summary report"
      ctaRoute="/reports/system/summary/group"
      closingText="Keep encouraging your students — every session is a step toward their reading goals."
    >
      <table table class="table-wrap">
        <tr>
          <th class="th">Student</th>
          <th class="th">Last Login</th>
          <th class="th">Status</th>
        </tr>
        @for (notification of data(); track notification.alertID) {
          <tr>
            <td class="td">{{ notification.studentName }}</td>
            <td class="td" style="white-space:nowrap; color:#a2a2a2;">{{ notification.data.lastLogin }}</td>
            <td class="td"><span class="badge-warn">{{ notification.data.status }}</span></td>
          </tr>
        }
      </table>
    </wf-notification-layout>
  `,
  standalone: true
})
export class DelinquentLoginNotificationComponent {
  readonly data = input.required<TeacherNotification[] | null>();
  readonly ids = computed(() => {
    const notifications = this.data() ?? [];

    return { alerts: notifications.map(notification => notification.alertID) };
  });
  readonly steps: NotificationStep[] = [
    {
      title: 'Check in with the student',
      body: 'Find out what’s been getting in the way. Open the Group Summary report and check the <b>Last Usage Date</b> column for context.'
    },
    {
      title: 'Help them get back on track',
      body: 'Make sure they have protected time this week to complete a session. Even one login gets the momentum going again.'
    },
    {
      title: 'If the student is no longer using WordFlight',
      body: 'Go to <b>Enroll > Students List</b>, select the student, and choose <b>Delete</b> to archive them. This removes them from reports and future notifications.',
      variant: 'warn',
    },
  ];
}
